import { gql } from "@apollo/client";

export const OrganizationCareerTrackFragment = gql`
  fragment OrganizationCareerTrackFragment on CareerTrackNode {
    id
    title
    version
    team {
      id
      title
    }
    roles {
      edges {
        node {
          id
          title
          level
          roleType
          hasCurrentHolders
          hasHistory
          assignedUsers {
            edges {
              node {
                id
                name
                email
                avatar
              }
            }
          }
          responsibilities {
            edges {
              node {
                id
                content
                inReview
              }
            }
          }
          competencies {
            edges {
              node {
                id
                title
                appliesTo
                criteriaUniqueness
                criteria {
                  edges {
                    node {
                      id
                      content
                      level
                      inReview
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default gql`
  ${OrganizationCareerTrackFragment}
  query getOrganizationCareerTrack($careerTrackId: Int!) {
    careerTrack(id: $careerTrackId) {
      ...OrganizationCareerTrackFragment
    }
  }
`;
